module.exports = __webpack_public_path__ + "img/horizontal_1_1_8004.3bc3059f.png";